<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Solicitação de Reembolso</div>
            </div>
            <hr style="margin-top: -4px" />
            
            <!-- ✅ SEÇÃO: Dados da Solicitação -->
            <div class="col-12 mt-4 mb-2">
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="reimbursement-card-header">
                  <i
                    class="fas fa-user-circle text-primary"
                    style="font-size: 22px"
                  ></i>
                  <h3 class="mb-0 text-primary reimbursement-card-title">
                    Dados da Solicitação
                  </h3>
                  <div class="reimbursement-card-line reimbursement-card-line-primary"></div>
                </div>

                <div class="row">
                  <div class="col-md-5">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Nome do Colaborador
                    </label>
                    <v-select 
                      v-model="reimbursement_solicitation.user_id" 
                      :options="users" 
                      :reduce="(users) => users.id"
                      :label="'name'"
                      :filter="customFilterUsers"
                      @input="fillUserData"
                    ></v-select>
                  </div>

                  <div class="col-md-5">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Valor do adiantamento
                    </label>
                    <input 
                      v-model="advanceAmountBRL" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      disabled 
                    />
                  </div>

                  <div class="col-md-2">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Data
                    </label>
                    <input 
                      autocomplete="new-password" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      id="date" 
                      placeholder="" 
                      type="date"
                      v-model="reimbursement_solicitation.date" 
                      disabled 
                    />
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-4">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Banco
                    </label>
                    <input 
                      v-model="reimbursement_solicitation.deposit_bank" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                    />
                  </div>

                  <div class="col-md-4">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Agência
                    </label>
                    <input 
                      v-model="reimbursement_solicitation.branch" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      v-mask="'9999'" 
                    />
                  </div>

                  <div class="col-md-4">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Conta Corrente
                    </label>
                    <input 
                      v-model="reimbursement_solicitation.checking_account" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- ✅ SEÇÃO: Despesas -->
            <div class="col-12 mt-4 mb-2" v-if="isAguardandoPreenchimento">
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="reimbursement-card-header">
                  <i
                    class="fas fa-receipt text-warning"
                    style="font-size: 22px"
                  ></i>
                  <h3 class="mb-0 text-warning reimbursement-card-title">
                    Adicionar Nova Despesa
                  </h3>
                  <div 
                    class="reimbursement-card-line"
                    style="border-color: #ffc107; margin-bottom: 2px"
                  ></div>
                </div>

                <div class="row">
                  <div class="col-md-2">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Data da Despesa
                    </label>
                    <input 
                      v-model="date_reimbursement" 
                      type="date" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                    />
                  </div>

                  <div class="col-md-5">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Tipo de Despesa
                    </label>
                    <v-select 
                      v-model="reimbursement_type_id" 
                      :options="reimbursement_types" 
                      :reduce="(reimbursement_types) => reimbursement_types.id" 
                      :label="'name'"
                    ></v-select>
                  </div>

                  <div class="col-md-3" v-show="isRateio">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Centro de Custo
                    </label>
                    <v-select 
                      v-model="bill_center_ids" 
                      :options="bill_centers"
                      :reduce="(bill_center) => bill_center.id" 
                      :label="'number_name'" 
                      multiple
                    ></v-select>
                  </div>

                  <div class="col-md-3" v-show="!isRateio">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Centro de Custo
                    </label>
                    <v-select 
                      v-model="bill_center_id" 
                      :options="bill_centers"
                      :reduce="(bill_centers) => bill_centers.id" 
                      :label="'number_name'"
                    ></v-select>
                  </div>

                  <div class="col-md-2 mt-2">
                    <div class="custom-control custom-switch">
                      <input 
                        autocomplete="new-password" 
                        placeholder="" 
                        type="checkbox" 
                        class="custom-control-input"
                        id="customSwitch1" 
                        v-model="isRateio" 
                      />
                      <label class="custom-control-label" for="customSwitch1">É rateio?</label>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-12">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Descrição da Despesa
                    </label>
                    <textarea 
                      v-model="expense_description" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      id="expense_description" 
                      cols="20"
                      rows="3"
                    ></textarea>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-6">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      <span class="required">*</span> Valor
                    </label>
                    <input 
                      v-model="amount" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      v-money="moneyConfig" 
                    />
                  </div>

                  <div class="col-md-6">
                    <label
                      :class="
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light'
                      "
                    >
                      Arquivo
                    </label>
                    <input 
                      type="file" 
                      id="images" 
                      ref="file" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                    />
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-12 text-right">
                    <button class="btn btn-primary" @click="incluirReembolso">
                      <i class="fas fa-plus"></i> Incluir Despesa
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ✅ SEÇÃO: Itens de Reembolso -->
            <div class="col-12 mt-4 mb-2" v-if="reimbursements.length > 0">
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="reimbursement-card-header">
                  <i
                    class="fas fa-list text-success"
                    style="font-size: 22px"
                  ></i>
                  <h3 class="mb-0 text-success reimbursement-card-title">
                    Itens de Reembolso
                  </h3>
                  <div
                    class="reimbursement-card-line"
                    style="border-color: #28a745; margin-bottom: 2px"
                  ></div>
                </div>

                <div class="col-md-12">
                  <table class="table table-bordered" style="width: 100%">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 20%">Data da Despesa</th>
                        <th scope="col" style="width: 20%">Tipo da Despesa</th>
                        <th scope="col" style="width: 20%">
                          Descrição da Despesa
                        </th>
                        <th scope="col" style="width: 20%">Centro de Custo</th>
                        <th scope="col" style="width: 20%">Valor</th>
                        <th scope="col" style="width: 20%">Arquivos</th>
                        <th scope="col" style="width: 20%">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(reimbursement, index) in reimbursements" :key="index">
                        <td>{{ reimbursement.date_reimbursement }}</td>
                        <td>
                          {{
                            getReimbursementTypeName(
                              reimbursement.reimbursement_type_id
                            )
                          }}
                        </td>
                        <td>{{ reimbursement.expense_description }}</td>
                        <td v-if="Array.isArray(reimbursement.bill_center)">
                          {{
                            getBillCenterNames(reimbursement.bill_center)
                          }}
                        </td>
                        <td v-else-if="
                          reimbursement.bill_center_id !== null &&
                          reimbursement.bill_center_id !== undefined
                        ">
                          {{ getBillCenterName(reimbursement.bill_center_id) }}
                        </td>
                        <td v-if="!reimbursement.bill_center_id">
                          Centro de custo não disponível
                        </td>
                        <td>{{ formatCurrency(reimbursement.amount) }}</td>
                        <td>
                          <span v-if="
                            reimbursement.file ||
                            (reimbursement.files && reimbursement.files.name)
                          ">
                            {{
                              reimbursement.file
                                ? reimbursement.file
                                : reimbursement.files.name
                            }}
                          </span>
                          <span v-else> Nenhum arquivo </span>

                          <a class="btn btn-add mr-1" :href="reimbursement.file_url" target="_blank"
                            v-if="reimbursement.file">
                            <i class="fas fa-download"></i>
                          </a>
                        </td>
                        <td>
                          <button class="btn btn-crud delete" @click="
                            deleteReimbursement(
                              reimbursements[index].id,
                              index
                            )
                            ">
                            <i class="far fa-trash-alt" data-toggle="tooltip" title="Excluir"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- ✅ SEÇÃO: Resumo Financeiro -->
            <div class="col-12 mt-4 mb-2">
              <div
                :class="[
                  'reimbursement-card',
                  $store.state.appConfig.layout.skin === 'dark'
                    ? 'reimbursement-card-dark'
                    : 'reimbursement-card-light',
                ]"
              >
                <div class="reimbursement-card-header">
                  <i
                    class="fas fa-calculator text-info"
                    style="font-size: 22px"
                  ></i>
                  <h3 class="mb-0 text-info reimbursement-card-title">
                    Resumo Financeiro
                  </h3>
                  <div
                    class="reimbursement-card-line"
                    style="border-color: #17a2b8; margin-bottom: 2px"
                  ></div>
                </div>

                <div class="row">
                  <div class="col-md-6" v-if="!reimbursement_solicitation.is_dinner_advance">
                    <label
                      :class="[
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light',
                      ]"
                    >
                      <span class="required">*</span> Saldo a receber (devolver)
                    </label>
                    <input 
                      :value="balanceToReceiveBRL" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      disabled 
                    />
                    <span v-if="balanceToReceive > 0" class="text-danger">(Devolver a IT4D)</span>
                    <span v-else-if="balanceToReceive < 0" class="text-success">(Devolver ao Colaborador)</span>
                  </div>

                  <div :class="reimbursement_solicitation.is_dinner_advance ? 'col-md-12' : 'col-md-6'">
                    <label
                      :class="[
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-label-dark'
                          : 'reimbursement-label-light',
                      ]"
                    >
                      <span class="required">*</span> Total dos gastos
                    </label>
                    <input 
                      :value="totalExpensesBRL" 
                      type="text" 
                      :class="[
                        'form-control',
                        $store.state.appConfig.layout.skin === 'dark'
                          ? 'reimbursement-input-dark'
                          : 'reimbursement-input-light',
                      ]"
                      disabled 
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <span class="required_fields">
                <span class="required">*</span>
                <strong>Campos obrigatórios</strong>
              </span>
              <div class="block text-right mb-1">
                <router-link :to="backRoute" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <a class="btn btn-add ml-1" @click="partialSave">
                  Salvar parcial <i class="fa fa-save"></i>
                </a>
                <a v-if="isAdvanceMode" class="btn btn-add ml-1" @click="submitAccountability">
                  Enviar prestação de contas
                  <i class="fa fa-paper-plane"></i>
                </a>
                <a v-else class="btn btn-add ml-1" @click="save">
                  Salvar
                  <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="modal fade" id="modalRejeitar" tabindex="-1" role="dialog" aria-labelledby="modalRejeitarTitle"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLongTitle">
                    Editar Solicitação
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row justify-content-center">
                    <div class="col-md-12">
                      <label>Observação</label>
                      <textarea class="form-control" cols="30" rows="10"
                        v-model="reimbursement_solicitation.observation_edit"></textarea>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Fechar
                  </button>
                  <button type="button" class="btn btn-primary" @click="saveWithObservation">
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Money from "v-money";

export default {
  name: "imageUpload",
  data() {
    return {
      isRateio: false,
      bill_center_ids: [],
      moneyConfig: {
        prefix: "R$ ",
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      reimbursement_solicitation: {
        user_id: "",
        date: "",
        checking_account: "",
        balance_to_receive: 0,
        branch: "",
        deposit_bank: "",
        bill_center_id: "",
        total_expenses: 0,
        approve: 0,
      },
      reimbursements: [],
      reimbursement_types: [],
      expense_description: "",
      reimbursement_solicitation_id: "",
      reimbursement_type_id: "",
      bill_center_id: "",
      amount: "",
      advance_amount: "",
      date_reimbursement: "",
      file: "",
      bill_centers: [],
      users: [],
      base64: "",
    };
  },
  computed: {

    backRoute() {
      // Detecta se é adiantamento para voltar para a tela correta
      const isAdvance = this.reimbursement_solicitation?.is_advance == "1" || 
                        this.reimbursement_solicitation?.is_advance === 1 ||
                        (this.reimbursement_solicitation?.advance_amount && 
                         Number(this.reimbursement_solicitation.advance_amount) > 0);
      return isAdvance ? '/advances' : '/reimbursement_solicitations';
    },

    isAdvanceMode() {
      return Number(this.reimbursement_solicitation?.is_advance) === 1;
    },

    isAguardandoPreenchimento() {
      const rs = this.reimbursement_solicitation
      return rs && Number(rs.approve) === 4
    },

    totalExpenses() {
      return (this.reimbursements || []).reduce((acc, r) => {
        const n = Number(
          String(r.amount)
            .replace(/[^\d,.-]/g, '')     // remove R$, pontos, etc
            .replace(/\.(?=\d{3}(,|$))/g, '') // tira separador de milhar
            .replace(',', '.')
        );
        return acc + (isFinite(n) ? n : 0);
      }, 0);
    },
    balanceToReceive() {
      // Se for adiantamento de jantar, saldo sempre é 0
      const isDinnerAdvance = Boolean(Number(this.reimbursement_solicitation?.is_dinner_advance));
      if (isDinnerAdvance) {
        return 0;
      }
      
      const adv = Number(this.reimbursement_solicitation?.advance_amount || 0);
      // Adiantamento - Total dos gastos
      // Se positivo: colaborador deve devolver à IT4D
      // Se negativo: IT4D deve pagar ao colaborador
      return adv - this.totalExpenses;
    },
    totalExpensesBRL() {
      return this.totalExpenses.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    balanceToReceiveBRL() {
      return Math.abs(this.balanceToReceive).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },

    formattedAdvanceAmount() {
      const v = parseFloat(this.reimbursement_solicitation.advance_amount);
      if (isNaN(v) || v <= 0) return "";
      return `R$ ${v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    },

    advanceAmountBRL() {
      const n = Number(this.reimbursement_solicitation?.advance_amount);
      if (!isFinite(n) || n <= 0) return '';
      return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
  },
  watch: {
    isRateio(newVal, oldVal) {
      if (newVal) {
        this.bill_center_id = null;
      } else {
        this.bill_center_ids = [];
      }
    },
  },
  methods: {

    // Função para normalizar strings removendo acentos
    normalizeString(str) {
      if (!str) return '';
      return str
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },

    // Filtro customizado para busca de usuários ignorando acentos
    customFilterUsers(options, search) {
      const normalizedSearch = this.normalizeString(search);
      return options.filter(option => {
        const normalizedName = this.normalizeString(option.name);
        return normalizedName.includes(normalizedSearch);
      });
    },

    async ensureSolicitation() {
      const self = this;
      let api = self.$store.state.api + "reimbursement_solicitations";
      const fd = new FormData();

      // se já existe -> PUT; senão -> POST (rascunho)
      if (self.reimbursement_solicitation.id) {
        api += "/" + self.reimbursement_solicitation.id;
        fd.append("_method", "PUT");
      }

      // campos essenciais do cabeçalho (sem approve / sem modal)
      fd.append("reimbursement_solicitation[user_id]", self.reimbursement_solicitation.user_id);
      fd.append("reimbursement_solicitation[date]", self.reimbursement_solicitation.date);
      fd.append("reimbursement_solicitation[checking_account]", self.reimbursement_solicitation.checking_account || "");
      fd.append("reimbursement_solicitation[branch]", self.reimbursement_solicitation.branch || "");
      fd.append("reimbursement_solicitation[deposit_bank]", self.reimbursement_solicitation.deposit_bank || "");
      fd.append("reimbursement_solicitation[total_expenses]", self.reimbursement_solicitation.total_expenses || 0);
      fd.append("reimbursement_solicitation[balance_to_receive]", self.reimbursement_solicitation.balance_to_receive || 0);

      if (typeof self.reimbursement_solicitation.advance_amount !== "undefined") {
        fd.append("reimbursement_solicitation[advance_amount]", Number(self.reimbursement_solicitation.advance_amount || 0));
      }

      const resp = await axios.post(api, fd);
      const payload = resp?.data?.data;
      if (!self.reimbursement_solicitation.id && (payload?.id || payload?.[0]?.id)) {
        self.reimbursement_solicitation.id = payload.id || payload[0].id;
      }
      return self.reimbursement_solicitation.id;
    },

    buildReimbursementFD(item) {
      const fd = new FormData();
      fd.append("reimbursement_type_id", item.reimbursement_type_id);
      fd.append("expense_description", item.expense_description || "");
      fd.append("amount", item.amount || 0);
      fd.append("advance_amount", item.advance_amount || 0);
      fd.append("date_reimbursement", item.date_reimbursement || "");

      if (item.bill_center_id) {
        fd.append("bill_center_id", item.bill_center_id);
      }
      if (item.bill_center_ids && Array.isArray(item.bill_center_ids)) {
        item.bill_center_ids.forEach((id) => fd.append("bill_center_ids[]", id));
      }

      // arquivos
      if (item.files) fd.append("files", item.files);
      if (item.file) fd.append("file", item.file);

      return fd;
    },

    async upsertReimbursement(solicitationId, item) {
      const self = this;

      // UPDATE item existente
      if (item.id) {
        const apiUpdate = self.$store.state.api + "reimbursements/" + item.id;
        const fd = self.buildReimbursementFD(item);
        fd.append("_method", "PUT");
        await axios.post(apiUpdate, fd);
        return;
      }

      // CREATE item novo
      const apiCreate = self.$store.state.api + `reimbursement_solicitations/${solicitationId}/reimbursements`;
      const fd = self.buildReimbursementFD(item);
      await axios.post(apiCreate, fd);
    },


    async partialSave(options = {}) {
      const self = this;
      const silent = options.silent === true;

      // validações mínimas do cabeçalho
      if (!self.reimbursement_solicitation.user_id) {
        self.$message(null, "Selecione o colaborador antes de salvar.", "error");
        return;
      }
      if (!self.reimbursement_solicitation.date) {
        self.$message(null, "Defina a data da solicitação.", "error");
        return;
      }

      // mantém totais coerentes
      self.calculateTotalExpenses();
      self.calculateBalanceToReceive();

      // endpoint do cabeçalho
      let api = self.$store.state.api + "reimbursement_solicitations";
      const fd = new FormData();

      // se já existe -> PUT via _method; senão -> POST
      if (self.reimbursement_solicitation.id) {
        api += "/" + self.reimbursement_solicitation.id;
        fd.append("_method", "PUT");
      }

      // FLAG que o backend usa para não mudar status nem enviar e-mails
      fd.append("partial", 1);

      // cabeçalho (não enviar approve/observation_edit aqui)
      fd.append("reimbursement_solicitation[user_id]", self.reimbursement_solicitation.user_id);
      fd.append("reimbursement_solicitation[date]", self.reimbursement_solicitation.date);
      fd.append("reimbursement_solicitation[checking_account]", self.reimbursement_solicitation.checking_account || "");
      fd.append("reimbursement_solicitation[branch]", self.reimbursement_solicitation.branch || "");
      fd.append("reimbursement_solicitation[deposit_bank]", self.reimbursement_solicitation.deposit_bank || "");
      fd.append("reimbursement_solicitation[total_expenses]", self.reimbursement_solicitation.total_expenses || 0);
      fd.append("reimbursement_solicitation[balance_to_receive]", self.reimbursement_solicitation.balance_to_receive || 0);

      if (typeof self.reimbursement_solicitation.advance_amount !== "undefined") {
        fd.append("reimbursement_solicitation[advance_amount]", Number(self.reimbursement_solicitation.advance_amount || 0));
      }
      if (typeof self.reimbursement_solicitation.is_advance !== "undefined") {
        fd.append("reimbursement_solicitation[is_advance]", self.reimbursement_solicitation.is_advance ? 1 : 0);
      }

      // despesas em lote (o controller update/create processa cada uma)
      (self.reimbursements || []).forEach((element, index) => {
        if (element.id) {
          fd.append(`reimbursements[${index}][id]`, element.id);
        }
        fd.append(`reimbursements[${index}][reimbursement_type_id]`, element.reimbursement_type_id);
        fd.append(`reimbursements[${index}][expense_description]`, element.expense_description || "");
        fd.append(`reimbursements[${index}][amount]`, element.amount || 0);
        fd.append(`reimbursements[${index}][advance_amount]`, element.advance_amount || 0);
        fd.append(`reimbursements[${index}][date_reimbursement]`, element.date_reimbursement || "");

        // centro de custo único
        if (element.bill_center_id) {
          fd.append(`reimbursements[${index}][bill_center_id]`, element.bill_center_id);
        }
        // rateio (múltiplos CCs)
        if (element.bill_center_ids && Array.isArray(element.bill_center_ids)) {
          element.bill_center_ids.forEach((id) => {
            fd.append(`reimbursements[${index}][bill_center_ids][]`, id);
          });
        }

        // arquivo (File do input)
        if (element.files) fd.append(`reimbursements[${index}][files]`, element.files);
        // nome de arquivo existente (quando já salvo)
        if (element.file) fd.append(`reimbursements[${index}][file]`, element.file);
      });

      try {
        self.$loading(true);

        // única chamada — cabeçalho + itens
        const resp = await axios.post(api, fd);

        // se já estamos editando, recarrega para refletir ids/arquivos dos itens
        const id = self.reimbursement_solicitation.id || self.$route.params.id;
        if (id) {
          await self.getReimbursementSolicitations(id);
          await self.getReimbursements(id);
        }

        if (!silent) {
          self.$message("Salvo parcialmente", "Despesas e cabeçalho salvos sem finalizar a solicitação.", "success");
        }
        return true;
      } catch (err) {
        const data = err?.response?.data;
        self.$message(null, (data && data.message) || data || "Falha ao salvar parcialmente.", "error");
        return false;
      } finally {
        self.$loading(false);
      }
    },

    // Adiantamento: salva as despesas e envia a prestação de contas para análise do gestor
    async submitAccountability() {
      const self = this;
      const items = self.reimbursements || [];

      if (!items.length) {
        self.$message(null, "Inclua ao menos uma despesa antes de enviar a prestação de contas.", "error");
        return;
      }
      if (items.some((item) => !item.files && !item.file)) {
        self.$message(null, "Todas as despesas precisam ter o comprovante anexado.", "error");
        return;
      }

      const confirmed = await swal({
        title: "Enviar prestação de contas?",
        text: "Depois de enviada, as despesas não poderão mais ser alteradas e seguirão para análise do gestor.",
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", value: false, visible: true, className: "btn-secondary" },
          confirm: { text: "Enviar", value: true, className: "btn-primary" },
        },
      });
      if (!confirmed) return;

      const saved = await self.partialSave({ silent: true });
      if (!saved) return;

      const id = self.reimbursement_solicitation.id || self.$route.params.id;
      try {
        self.$loading(true);
        const resp = await axios.post(self.$store.state.api + `advances/${id}/submit_accountability`);
        self.$message("Sucesso", resp.data.message, "success");
        self.$router.push(`/advances/view/${id}`);
      } catch (err) {
        self.$message(null, err?.response?.data?.message || "Falha ao enviar a prestação de contas.", "error");
      } finally {
        self.$loading(false);
      }
    },




    getReimbursementTypeName(reimbursementTypeId) {
      const reimbursementType = this.reimbursement_types.find(
        (type) => type.id === reimbursementTypeId
      );

      return reimbursementType ? reimbursementType.name : "Tipo não encontrado";
    },

    getBillCenterNames(billCenterIds) {
      const ids = Array.isArray(billCenterIds)
        ? billCenterIds
        : billCenterIds.split(",").map((id) => parseInt(id, 10));

      const names = ids.map((id) => {
        const billCenter = this.bill_centers.find(
          (bill_center) => bill_center.id === id
        );
        return billCenter
          ? billCenter.number_name
          : "Centro de custo não encontrado";
      });

      return names.join(", ");
    },

    getBillCenterName(billCenterId) {
      const billCenter = this.bill_centers.find(
        (bill_center) => bill_center.id === billCenterId
      );

      return billCenter
        ? billCenter.number_name
        : "Centro de custo não encontrado";
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    convertCurrencyToNumber(currencyString) {
      const cleanedString = String(currencyString)
        .replace(/\s|R\$/g, "")
        .replace(".", "");

      const dotFormattedString = cleanedString.replace(",", ".");

      const numberValue = parseFloat(dotFormattedString);

      return isNaN(numberValue) ? 0 : numberValue;
    },

    deleteReimbursement(id, index) {
      const self = this;

      swal({
        title: "Deseja deletar o reembolso?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O reembolso não foi excluído!", "info");
            break;

          case "confirm":
            let api = self.$store.state.api + `reimbursements/${id}`;
            axios
              .delete(api, { id: id })
              .then((response) => {
                swal("Sucesso", "Reembolso excluído com sucesso!", "success");

                self.reimbursements.splice(index, 1);
                self.calculateTotalExpenses();
                self.calculateBalanceToReceive();
              })
              .catch((error) => {
                swal(
                  "Erro",
                  "Este reembolso não pode ser deletado, pois já está sendo utilizado no sistema!",
                  "error"
                );
              });
            break;
        }
      });
    },
    incluirReembolso() {
      const self = this;

      let fileInput = document.getElementById("images");
      const file = fileInput.files[0];

      if (this.advance_amount == "") {
        this.advance_amount = this.advance_amount;
      }

      if (this.reimbursement_type_id === "") {
        this.$message(null, "O tipo da despesa é obrigatório", "error");
        return;
      }

      if (this.date_reimbursement === "") {
        this.$message(null, "A data da despesa é obrigatória", "error");
        return;
      }

      if (!file) {
        this.$message(null, "O arquivo é obrigatório", "error");
        return;
      }

      const today = new Date();
      const reimbursementDate = new Date(this.date_reimbursement);

      if (reimbursementDate > today) {
        this.$message(
          null,
          "A data do despesa não pode ser maior que hoje",
          "error"
        );
        return;
      }

      if (this.expense_description === "") {
        this.$message(null, "A descrição da despesa é obrigatória", "error");
        return;
      }

      if (this.isRateio) {
        if (
          !Array.isArray(this.bill_center_ids) ||
          this.bill_center_ids.length === 0
        ) {
          this.$message(null, "Selecione ao menos um centro de custo", "error");
          return;
        }
      } else {
        if (!this.bill_center_id) {
          this.$message(null, "O centro de custo é obrigatório", "error");
          return;
        }
      }

      const amountNumber = this.convertCurrencyToNumber(this.amount);
      const advanceAmountNumber = this.convertCurrencyToNumber(
        this.advance_amount
      );

      const newReimbursement = {
        reimbursement_type_id: self.reimbursement_type_id,
        expense_description: self.expense_description,
        amount: amountNumber,
        advance_amount: advanceAmountNumber,
        date_reimbursement: self.date_reimbursement,
        files: file,
        bill_center_id: self.bill_center_id,
        bill_center_ids: self.bill_center_ids,
      };

      self.reimbursements.push(newReimbursement);

      self.expense_description = "";
      self.reimbursement_type_id = "";
      self.amount = "";
      // this.advance_amount = "";
      self.$refs.file.value = "";
      self.date_reimbursement = "";
      self.bill_center_id = "";
      self.bill_center_ids = [];
      self.isRateio = false;

      self.calculateTotalExpenses();
      self.calculateBalanceToReceive();
    },

    makeFormData() {
      const fd = new FormData();

      // Adicione outros campos ao FormData, se necessário
      fd.append("_method", "PUT");

      return fd;
    },

    save: function () {
      const self = this;

      self.calculateTotalExpenses();
      self.calculateBalanceToReceive();

      // Validação dos campos obrigatórios
      if (
        this.reimbursement_solicitation.user_id === "" ||
        this.reimbursement_solicitation.user_id === null
      ) {
        this.$message(null, "O Nome é obrigatório", "error");
        return false;
      }

      if (
        this.reimbursement_solicitation.date === "" ||
        this.reimbursement_solicitation.date === null
      ) {
        this.$message(null, "A Data é obrigatória", "error");
        return false;
      }

      if (
        this.reimbursement_solicitation.deposit_bank === "" ||
        this.reimbursement_solicitation.deposit_bank === null
      ) {
        this.$message(null, "O Banco é obrigatório", "error");
        return false;
      }

      if (
        this.reimbursement_solicitation.branch === "" ||
        this.reimbursement_solicitation.branch === null
      ) {
        this.$message(null, "A Agência é obrigatória", "error");
        return false;
      }

      if (
        this.reimbursement_solicitation.checking_account === "" ||
        this.reimbursement_solicitation.checking_account === null
      ) {
        this.$message(null, "A Conta Corrente é obrigatória", "error");
        return false;
      }

      if (this.reimbursement_solicitation.total_expenses === 0) {
        this.$message(
          null,
          "O Total não pode ser 0, favor informar um Valor.",
          "error"
        );
        return false;
      }

      // Exibe o modal de confirmação antes de salvar
      $("#modalRejeitar").modal("show");
    },

    saveWithObservation: function () {
      const self = this;

      // Valida se o campo de observação foi preenchido
      if (!self.reimbursement_solicitation.observation_edit) {
        swal("Aviso", "Por favor, preencha o campo de observação!", "warning");
        return;
      }

      // Realiza a requisição para salvar as informações
      let api = self.$store.state.api + "reimbursement_solicitations";
      let fd = self.makeFormData();

      if (self.reimbursement_solicitation.id) {
        api += "/" + self.reimbursement_solicitation.id;
        self.reimbursement_solicitation._method = "PUT";
      }

      // Adiciona os dados ao FormData
      fd.append(
        "reimbursement_solicitation[user_id]",
        self.reimbursement_solicitation.user_id
      );
      fd.append(
        "reimbursement_solicitation[date]",
        self.reimbursement_solicitation.date
      );
      fd.append(
        "reimbursement_solicitation[checking_account]",
        self.reimbursement_solicitation.checking_account
      );
      fd.append(
        "reimbursement_solicitation[balance_to_receive]",
        self.reimbursement_solicitation.balance_to_receive
      );
      fd.append(
        "reimbursement_solicitation[branch]",
        self.reimbursement_solicitation.branch
      );
      fd.append(
        "reimbursement_solicitation[deposit_bank]",
        self.reimbursement_solicitation.deposit_bank
      );
      fd.append(
        "reimbursement_solicitation[total_expenses]",
        self.reimbursement_solicitation.total_expenses
      );
      fd.append(
        "reimbursement_solicitation[approve]",
        self.reimbursement_solicitation.approve
      );
      fd.append(
        "reimbursement_solicitation[observation_edit]",
        self.reimbursement_solicitation.observation_edit
      ); // Campo de observação.

      self.reimbursements.forEach((element, index) => {
        fd.append(
          "reimbursements[" + index + "][reimbursement_type_id]",
          element.reimbursement_type_id
        );
        fd.append(
          "reimbursements[" + index + "][expense_description]",
          element.expense_description
        );
        fd.append("reimbursements[" + index + "][amount]", element.amount);
        fd.append(
          "reimbursements[" + index + "][advance_amount]",
          element.advance_amount
        );
        fd.append(
          "reimbursements[" + index + "][date_reimbursement]",
          element.date_reimbursement
        );

        // Adiciona apenas o campo relevante
        if (element.bill_center_id) {
          fd.append(
            "reimbursements[" + index + "][bill_center_id]",
            element.bill_center_id
          );
        }

        if (element.bill_center_ids && Array.isArray(element.bill_center_ids)) {
          element.bill_center_ids.forEach((id) => {
            fd.append("reimbursements[" + index + "][bill_center_ids][]", id);
          });
        }

        fd.append("reimbursements[" + index + "][files]", element.files);
        fd.append("reimbursements[" + index + "][file]", element.file);
        fd.append("reimbursements[" + index + "][id]", element.id);
      });

      self.$loading(true);

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          this.$router.push(this.backRoute);
          self.$loading(false);
          $("#modalRejeitar").modal("hide"); // Fecha o modal após salvar
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },

    calculateTotalExpenses() {
      let totalExpenses = this.reimbursements.reduce((total, reimbursement) => {
        const amount = parseFloat(reimbursement.amount);
        return isNaN(amount) ? total : total + amount;
      }, 0);

      this.reimbursement_solicitation.total_expenses = totalExpenses;
    },

    calculateBalanceToReceive() {
      this.calculateTotalExpenses();

      // Se for adiantamento de jantar, o saldo a receber sempre é 0
      const isDinnerAdvance = Boolean(Number(this.reimbursement_solicitation.is_dinner_advance));
      if (isDinnerAdvance) {
        this.reimbursement_solicitation.balance_to_receive = 0;
      } else {
        // Usa o valor do adiantamento salvo na solicitação para o cálculo
        const savedAdvanceAmount = this.reimbursement_solicitation.advance_amount || 0;
        this.reimbursement_solicitation.balance_to_receive =
          savedAdvanceAmount - this.reimbursement_solicitation.total_expenses;
      }
    },

    getReimbursementSolicitations(id) {
      const api =
        this.$store.state.api +
        "reimbursement_solicitations/" +
        id +
        "?with[]=attachments&with[]=reimbursements";

      axios.get(api)
        .then((response) => {
          const s = response?.data?.data?.[0] || {};

          // Merge para não perder campos locais
          this.reimbursement_solicitation = {
            ...this.reimbursement_solicitation,
            ...s,
          };

          if (Number(s.is_advance) === 1 && Number(s.approve) !== 4) {
            this.$router.replace(`/advances/view/${s.id}`);
            return;
          }

          // GUARDE COMO NÚMERO (não formate aqui)
          this.reimbursement_solicitation.advance_amount = Number(s.advance_amount || 0);

          // (opcional) recalcula o saldo, se quiser manter atualizado
          this.calculateBalanceToReceive();
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
        });
    },


    getReimbursements: function (solicitation_id) {
      const self = this;

      let api =
        self.$store.state.api +
        `reimbursement_solicitations/${solicitation_id}/reimbursements`;

      axios
        .get(api)
        .then((response) => {
          // Aqui, você pode decidir se quer carregar novamente ou deixar vazio, dependendo da sua necessidade.
          self.reimbursements = response.data; // Força o array de reembolsos a ficar vazio
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getReimbursementTypes: function () {
      const self = this;
      const api = self.$store.state.api + "reimbursement_types/";

      axios
        .get(api)
        .then((response) => {
          self.reimbursement_types = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getBillCenters: function () {
      const self = this;
      const api = self.$store.state.api + "bill_centers?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.bill_centers = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users_solicitation";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.users;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    fillUserData(selectedUserId) {
      const selectedUser = this.users.find(
        (user) => user.id === selectedUserId
      );
      if (selectedUser) {
        this.reimbursement_solicitation.deposit_bank =
          selectedUser.deposit_bank || "";
        this.reimbursement_solicitation.branch = selectedUser.branch || "";
        this.reimbursement_solicitation.checking_account =
          selectedUser.checking_account || "";
      }
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getReimbursementTypes();
    self.getBillCenters();
    self.getUsers();

    if (id) {
      self.getReimbursementSolicitations(id);
      self.getReimbursements(id);
    } else {
      self.reimbursement_solicitation.date = moment().format("YYYY-MM-DD");
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Money,
  },
};
</script>
<style scoped>
/* força o loader global a ficar acima do modal bootstrap */
.vue-loading,
.vue-loading-overlay,
.loading-overlay,
.loading-background {
  position: fixed !important;
  z-index: 99999 !important;
  top: 0;
  left: 0;
}

.vue-loading-overlay.is-full-page {
  z-index: 99999 !important;
}

.profile_user {
  text-align: center;
}

.attachment_url {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.attachment_url-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

/* ===== ESTILIZAÇÃO MODERNA - IGUAL DASP/VIEW ===== */

/* Cards - Classes separadas para dark e light */
.reimbursement-card {
  border-radius: 12px;
  padding: 24px 18px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.reimbursement-card-dark {
  background: #191e2e;
  border: 1px solid #4a5568;
}

.reimbursement-card-light {
  background: #f8f8fa;
  border: 1px solid #e2e6ea;
}

.reimbursement-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.reimbursement-card-title {
  font-weight: 700;
}

.reimbursement-card-line {
  flex: 1;
  border-bottom: 4px solid;
  margin-left: 16px;
  opacity: 0.6;
}

.reimbursement-card-line-primary {
  border-color: #007bff;
}

/* Labels */
.reimbursement-label-dark {
  color: #e2e8f0;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

.reimbursement-label-light {
  color: #2d3748;
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

/* Inputs */
.reimbursement-input-dark {
  background: #2d3748;
  border: 1px solid #4a5568;
  color: #e2e8f0;
}

.reimbursement-input-light {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #2d3748;
}

/* Cards internos */
.reimbursement-inner-card-dark {
  background: #232b3e;
  border: 1px solid #4a5568;
  border-radius: 12px;
}

.reimbursement-inner-card-light {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 12px;
}

/* ===== RESPONSIVIDADE MOBILE ===== */
@media (max-width: 768px) {
  .reimbursement-card {
    padding: 1rem 0.75rem !important;
    margin-bottom: 1rem;
  }

  .reimbursement-card-header {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .reimbursement-card-header i {
    font-size: 18px !important;
  }

  .reimbursement-card-title {
    font-size: 1.1rem !important;
    margin: 0 !important;
  }

  .reimbursement-card-line {
    width: 100%;
    margin-left: 0 !important;
    margin-top: 0.5rem;
  }

  .reimbursement-label-dark,
  .reimbursement-label-light {
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }
}

/* ===== RESPONSIVIDADE TABLET ===== */
@media (min-width: 769px) and (max-width: 1024px) {
  .reimbursement-card {
    padding: 1.25rem;
  }
}
</style>